export default __webpack_public_path__ + "static/media/sidebar-close.60d5d0c8.svg";